export default __webpack_public_path__ + "static/media/start-again.4c343787.svg";